var map = {
	"./customer/Root": "ac21",
	"./customer/Root.vue": "ac21",
	"./customer/components/Addresses": "8e06",
	"./customer/components/Addresses.vue": "8e06",
	"./customer/components/CustomerButtons": "7245",
	"./customer/components/CustomerButtons.vue": "7245",
	"./customer/components/CustomerDelete": "39e6",
	"./customer/components/CustomerDelete.js": "39e6",
	"./customer/components/CustomerForm": "facf",
	"./customer/components/CustomerForm.vue": "facf",
	"./customer/components/CustomerListTable": "672c",
	"./customer/components/CustomerListTable.vue": "672c",
	"./customer/components/CustomerModel": "efd6",
	"./customer/components/CustomerModel.js": "efd6",
	"./customer/components/CustomerPage": "12ec",
	"./customer/components/CustomerPage.vue": "12ec",
	"./customer/routes": "12fd",
	"./customer/routes.js": "12fd",
	"./customer/store": "53ad",
	"./customer/store.js": "53ad",
	"./customer/views/CustomerCreate": "e1f9",
	"./customer/views/CustomerCreate.vue": "e1f9",
	"./customer/views/CustomerEdit": "c381",
	"./customer/views/CustomerEdit.vue": "c381",
	"./customer/views/CustomerList": "57c9",
	"./customer/views/CustomerList.vue": "57c9",
	"./quotation/Root": "302d",
	"./quotation/Root.vue": "302d",
	"./quotation/components/ImportModals": "9341",
	"./quotation/components/ImportModals.vue": "9341",
	"./quotation/components/QuotationButtons": "5fdd",
	"./quotation/components/QuotationButtons.vue": "5fdd",
	"./quotation/components/QuotationDelete": "05c8",
	"./quotation/components/QuotationDelete.js": "05c8",
	"./quotation/components/QuotationForm": "8af3",
	"./quotation/components/QuotationForm.vue": "8af3",
	"./quotation/components/QuotationListTable": "2e41",
	"./quotation/components/QuotationListTable.vue": "2e41",
	"./quotation/components/QuotationModel": "a272",
	"./quotation/components/QuotationModel.js": "a272",
	"./quotation/components/modal/AddCustomerModal": "4aa9",
	"./quotation/components/modal/AddCustomerModal.vue": "4aa9",
	"./quotation/components/modal/BlindsQuotationModal": "b99c",
	"./quotation/components/modal/BlindsQuotationModal.vue": "b99c",
	"./quotation/components/modal/MarkAsSentModal": "f795",
	"./quotation/components/modal/MarkAsSentModal.vue": "f795",
	"./quotation/components/modal/PrintManufactureModal": "966d",
	"./quotation/components/modal/PrintManufactureModal.vue": "966d",
	"./quotation/components/modal/PrintWarrantyModal": "adf7",
	"./quotation/components/modal/PrintWarrantyModal.vue": "adf7",
	"./quotation/components/modal/SendEmailModal": "f575",
	"./quotation/components/modal/SendEmailModal.vue": "f575",
	"./quotation/components/modal/SendWhatsappModal": "b73c",
	"./quotation/components/modal/SendWhatsappModal.vue": "b73c",
	"./quotation/routes": "9d76",
	"./quotation/routes.js": "9d76",
	"./quotation/store": "38a8",
	"./quotation/store.js": "38a8",
	"./quotation/views/QuotationCreate": "acde",
	"./quotation/views/QuotationCreate.vue": "acde",
	"./quotation/views/QuotationEdit": "1673",
	"./quotation/views/QuotationEdit.vue": "1673",
	"./quotation/views/QuotationList": "84eb",
	"./quotation/views/QuotationList.vue": "84eb",
	"./settings/Root": "c5ec",
	"./settings/Root.vue": "c5ec",
	"./settings/components/CompanyForm": "2b6c",
	"./settings/components/CompanyForm.vue": "2b6c",
	"./settings/components/MessagesForm": "35d2",
	"./settings/components/MessagesForm.vue": "35d2",
	"./settings/components/QuotationTypesForm": "9825",
	"./settings/components/QuotationTypesForm.vue": "9825",
	"./settings/components/SettingsForm": "a85c",
	"./settings/components/SettingsForm.vue": "a85c",
	"./settings/components/SettingsModel": "0fe9",
	"./settings/components/SettingsModel.js": "0fe9",
	"./settings/components/TypesFormTemplate": "47be",
	"./settings/components/TypesFormTemplate.vue": "47be",
	"./settings/components/UserAccountDetails": "5cd3",
	"./settings/components/UserAccountDetails.vue": "5cd3",
	"./settings/components/UserDetails": "8428",
	"./settings/components/UserDetails.vue": "8428",
	"./settings/components/UserModel": "de8e",
	"./settings/components/UserModel.js": "de8e",
	"./settings/routes": "de76",
	"./settings/routes.js": "de76",
	"./settings/store": "dd3c",
	"./settings/store.js": "dd3c",
	"./settings/views/Settings": "7a1b",
	"./settings/views/Settings.vue": "7a1b",
	"./settings/views/UserProfileLite": "7485",
	"./settings/views/UserProfileLite.vue": "7485"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19dd";